import React, { useState, useEffect } from 'react'
import {
  useTranslate,
  required,
  TextInput,
  NumberInput,
  useNotify,
  SelectInput,
  Form,
  SelectArrayInput,
} from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Skeleton, Grid, Button, DialogActions } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import { documentTypeServices } from 'src/services/reservation/documentType/documentType.service'
import LoadingButton from '@mui/lab/LoadingButton'
import { useCardId } from 'src/components/pages/sales/reservation/context/CardIdContext'
import dayjs from 'dayjs'
import { completeDateDigitsPassengers } from '../../helper/completeDateDigitsPassengers'

export const ModalPassenger = ({
  item,
  open,
  handleClose,
  titleModal,
  onSubmit,
  record = undefined,
  loadingButton
}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [recordMask, setRecordMask] = useState({})
  const { cardId } = useCardId()
  const [optionsDocumentType, setOptionsDocumentType] = useState([])
  const [loadingDocumentType, setLoadingDocumentType] = useState(false)

  useEffect(() => {
    getDocumentType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setRecordMask({...record, birth_date:completeDateDigitsPassengers(record?.birth_date)})
  },[record])

  const getDocumentType = async () => {
    try {
      setLoadingDocumentType(true)
      const allDocumentType = await documentTypeServices.getByAll()
      if (allDocumentType) {
        setOptionsDocumentType(allDocumentType)
        setLoadingDocumentType(false)
        return
      }
      notify(`applications not found`, { type: 'error' })
      setLoadingDocumentType(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingDocumentType(false)
    }
  }

  const postSave = (data) => {
    const dataToSend = {
      ...data,
      age: data.birth_date ? dayjs().diff(dayjs(data.birth_date, 'DD-MM-YYYY'), 'years') : null,
    }
    onSubmit && onSubmit(dataToSend, cardId)
  }

  const textProductoItem = (choice) => `${choice?.external_id} - ${choice?.product?.long_name}`

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave} record={recordMask}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.product')} required>
              <SelectArrayInput
                source='item_relation'
                optionText={textProductoItem}
                optionValue='item_id'
                choices={item || []}
                label=''
                fullWidth
                disabled={!item || item.length === 0}
                validate={[required()]}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.surname')} required>
              <TextInput source='surname' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.type')}>
              <SelectInput
                source='type'
                optionText='name'
                optionValue='type'
                choices={[
                  { id: 1, name: translate('ra.field.adult'), type: 'ADT' },
                  { id: 2, name: translate('ra.field.child'), type: 'CHD' },
                  { id: 3, name: translate('ra.field.infant'), type: 'INF' },
                ]}
                label=''
                fullWidth
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_number')}>
              <NumberInput source='document_number' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.phone')}>
              <TextInput source='phone' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.email')}>
              <TextInput source='email' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.birth_date')}>
              <DatePickers source={`birth_date`} viewsShow={false} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_type')}>
              {loadingDocumentType ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='document_type_id'
                  optionText='long_name'
                  optionValue='id'
                  fullWidth
                  choices={optionsDocumentType}
                  label=''
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.country')}>
              <TextInput source='country' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.nationality')}>
              <TextInput source='nationality' label='' fullWidth />
            </EditInputsWrap>
          </Grid>
        </Form>

        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={loadingButton}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
